// Safe wrappers around window.localStorage.
//
// Some visitor browsers block storage access entirely (strict privacy
// settings, embedded webviews, third-party cookie blocking): every
// localStorage property access then throws
//   SecurityError: Failed to read the 'localStorage' property from
//   'Window': Access is denied for this document.
// (Sentry TRUSTPAGE-K). Storage here is best-effort only, so reads
// return null and writes are no-ops instead of crashing the caller.

export function safeGetItem(key) {
  try {
    return window.localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

export function safeSetItem(key, value) {
  try {
    window.localStorage.setItem(key, value)
  } catch (e) {
    // Storage blocked — drop the write.
  }
}

export function safeRemoveItem(key) {
  try {
    window.localStorage.removeItem(key)
  } catch (e) {
    // Storage blocked — nothing to remove.
  }
}
